
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'
export default function PasswordDisplay(props) {

    const display = props.display
    const setDisplay = props.setDisplay
    
    return (
        <button
            type="button"
            className={`password-display ${display ? 'show' : ''}`}
            onClick={() => {setDisplay(!display)}}
            aria-label={`${display ? '隱藏' : '顯示'}密碼`}
        >
            <EyeSlashIcon role="img" aria-label="密碼隱藏中" />
            <EyeIcon role="img" aria-label="密碼顯示中" />
        </button>
    )
}